import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/root';

export default function createAppStore() {
  const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
  });

  return store;
}
